import styled, { css } from 'styled-components';
import { size, spacing, ButtonReset } from 'ui';
import Animate from 'react-move/Animate';
import { Portal } from 'react-portal';
import { MdClear } from 'react-icons/md';

const Wrapper = styled.div`
  background-color: #fff;
  box-shadow: -8px 0 24px rgba(0, 0, 0, 0.25);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 380px;
  max-width: 100vw;
  height: 100%;
  z-index: 10;
  overflow: hidden;

  ${props =>
    props.side === 'left' &&
    css`
      right: auto;
      left: 0;
    `};
`;

const Overlay = styled.a`
  position: fixed;
  display: block;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 9;
  cursor: pointer;
`;

const Header = styled.header`
  padding: ${spacing(1.25)};
  border-bottom: 1px solid ${({ theme }) => theme.separator};
  position: relative;
`;

const Title = styled.h3`
  margin: 0;
`;

const Close = styled(ButtonReset)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: ${spacing()};
  font-size: ${size(1)};
  color: ${({ theme }) => theme.textLight};

  &:hover {
    color: ${({ theme }) => theme.text};
  }
`;

const Content = styled.div`
  padding: ${spacing()};
  padding-bottom: ${spacing(6)};
  overflow-y: auto;
  height: 100%;
`;

const Drawer = ({ title, children, shown, onRequestClose, side }) => (
  <Animate
    show={shown}
    start={{ opacity: 0, translate: side === 'right' ? 360 : -360 }}
    enter={[
      {
        opacity: [1],
        timing: {
          duration: 150,
        },
      },
      {
        translate: [0],
        timing: {
          duration: 150,
        },
      },
    ]}
    leave={[
      {
        opacity: [0],
        timing: {
          duration: 150,
        },
      },
      {
        translate: [side === 'right' ? 360 : -360],
        timing: {
          duration: 150,
        },
      },
    ]}
  >
    {({ opacity, translate }) => (
      <Portal>
        <Wrapper
          style={{ transform: `translateX(${translate}px)` }}
          side={side}
        >
          <Header>
            <Title>{title}</Title>
            <Close onClick={onRequestClose}>
              <MdClear />
            </Close>
          </Header>
          <Content>{children}</Content>
        </Wrapper>
        <Overlay onClick={onRequestClose} style={{ opacity }} />
      </Portal>
    )}
  </Animate>
);

Drawer.defaultProps = {
  side: 'right',
};

export default Drawer;
